module.exports = __webpack_public_path__ + "static/img/アセット 100@2x.6eef5b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/アセット 100@2x.png
// module id = EUS4
// module chunks = 1